import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const isAuth = authService.isAuth();
  const isRoot = state.url === '/';

  if (isRoot) {
    if (isAuth) {
      void router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }

  if (isAuth) {
    return true;
  }

  void router.navigate(['/']);
  return false;
};
